import { store } from "../store";
import { call, takeLatest } from "redux-saga/effects";

import ENV from "../config/env";
import axiosInstance from "../../api/axiosInstance";
import {
  CANDIDATE_FOR_JOBS_LISTING_REQUEST,
  COMPANY_DETAILS_SUMMARY_REQUEST,
  COMPANY_LISTING_REQUEST,
  JOB_DEACTIVATE_REQUEST,
  JOB_LISTING_FOR_CANDIDATE_REQUEST,
  JOB_LISTING_REQUEST,
} from "./listingApi.type";

function getErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error.message ||
    "Something went wrong"
  );
}
function getAuthHeaders() {
  const token = store.getState()?.auth?.accessToken;
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

function* jobListingSaga(action) {
  const { payload, callback } = action;
  let url;
  if (payload.pageFrom) {
    url = "/listing/Jobs?forHomePage=true";
  } else {
    url = "/listing/Jobs";
  }

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}${url}`,
      payload,
      getAuthHeaders(),
    );
    // yield put(saveJobDetailsSuccess(data));
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}
function* jobListingForCandidateSaga(action) {
  const {
    payload: { user, status, body },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/listing/CandidateJobs?candidateId=${user}&candidateJobApplicationStatus=${status}`,
      body,
      getAuthHeaders(),
    );
    // yield put(saveJobDetailsSuccess(data));
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}
function* candidateForJobsListingSaga(action) {
  const { payload, callback } = action;

  let url;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.CANDIDATE_SERVICES_URL}/listing/Candidates`,
      payload,
      getAuthHeaders(),
    );
    // yield put(saveJobDetailsSuccess(data));
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* deactiveApiSaga(action) {
  const {
    payload: { user, status },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/update/JobActiveFlag?id=${user}&active=${status}`,
      {},
      getAuthHeaders(),
    );
    // yield put(saveJobDetailsSuccess(data));
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* CompanyDetailsJobSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/get/CompanyDetailsSummary?id=${user}`,
      {},
      getAuthHeaders(),
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* companyListingSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMPANY_SERVICES_URL}/listing/Companies`,
      payload,
      getAuthHeaders(),
    );
    // yield put(saveJobDetailsSuccess(data));
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

export function* listingWatcherSaga() {
  yield takeLatest(JOB_LISTING_REQUEST, jobListingSaga);
  yield takeLatest(COMPANY_DETAILS_SUMMARY_REQUEST, CompanyDetailsJobSaga);

  yield takeLatest(
    JOB_LISTING_FOR_CANDIDATE_REQUEST,
    jobListingForCandidateSaga,
  );
  yield takeLatest(JOB_DEACTIVATE_REQUEST, deactiveApiSaga);

  yield takeLatest(
    CANDIDATE_FOR_JOBS_LISTING_REQUEST,
    candidateForJobsListingSaga,
  );
  yield takeLatest(COMPANY_LISTING_REQUEST, companyListingSaga);
}
